import { defineStore } from 'pinia'
import { reactive } from 'vue'

interface IStorePromises {
	fetchGoogleRatingsPromise: Promise<IGoogleRatingModel> | null
}

export interface IGoogleRatingsStoreState {
	googleRating: IGoogleRatingModel | null
	fetchingGoogleRating: boolean
}

export interface IGoogleRatingsStore {
	readonly state: {
		googleRating: IGoogleRatingModel | null
		fetchingGoogleRating: boolean
	}
	fetchGoogleRating: () => Promise<IGoogleRatingModel | undefined>
	setGoogleRating: (googleRating: IGoogleRatingModel) => void
	setFetchingGoogleRating: (fetchingGoogleRating: boolean) => void
	getGoogleRating: ComputedRef<IGoogleRatingModel | null>
	getFetchingGoogleRating: ComputedRef<boolean>
}

export const useGoogleRatingsStore = defineStore('googleRatingsStore', (): IGoogleRatingsStore => {
	const _state = reactive<IGoogleRatingsStoreState>({
		googleRating: null,
		fetchingGoogleRating: false,
	})

	const setGoogleRating = (googleRating: IGoogleRatingModel) => {
		_state.googleRating = googleRating
	}

	const promises: IStorePromises = {
		fetchGoogleRatingsPromise: null,
	}

	const fetchGoogleRating = async () => {
		try {
			if (_state.googleRating) {
				return _state.googleRating
			}

			if (promises.fetchGoogleRatingsPromise) {
				return promises.fetchGoogleRatingsPromise
			}

			promises.fetchGoogleRatingsPromise = (async () => {
				const fetchedGoogleRating = await ApiService.fetchGoogleRating()

				if (fetchedGoogleRating) {
					_state.googleRating = fetchedGoogleRating
				} else {
					_state.googleRating = null
				}

				return _state.googleRating as IGoogleRatingModel
			})()

			return await promises.fetchGoogleRatingsPromise
		} catch (error) {
			logger.log(error)
		}
	}

	const setFetchingGoogleRating = (fetchingGoogleRating: boolean) => {
		_state.fetchingGoogleRating = fetchingGoogleRating
	}

	const getGoogleRating = computed(() => _state.googleRating)

	const getFetchingGoogleRating = computed(() => _state.fetchingGoogleRating)

	return {
		state: _state,
		setGoogleRating,
		fetchGoogleRating,
		setFetchingGoogleRating,
		getGoogleRating,
		getFetchingGoogleRating,
	}
})
